import { timer } from 'rxjs';

// Services
import { AuthService } from '../services';
import { APP_CONFIG } from '../constants';


export class AuthGuard {

    subcription = null;

    constructor(timeStart, timeInterval) {

        this.timeStart = timeStart;
        this.timeInterval = timeInterval;
    }

    init(dispatch) {

        if ( APP_CONFIG.GUARDS.AUTH.REFRESH_TOKEN ) {

            this.subcription = timer(this.timeStart, this.timeInterval)
                .subscribe(() => {
    
                    AuthService.isAuthenticated()
                        .then( isAuthenticated => {
    
                            if ( !isAuthenticated ) {
            
                                this.end();
                                dispatch();
                            }
                        });
                });
        }
    }

    end() {

        if (this.subcription) {

            this.subcription.unsubscribe();
        }
    }
}